// extracted by mini-css-extract-plugin
export default {"root":"_0ll_7Q2","backButton":"isyK3Faj","backButtonNoPadding":"x3XHL8LB","backIcon":"QyC3cVX6","title":"N9RxwQRM","titleButton":"JoAY1rfJ"};